module.exports = __webpack_public_path__ + "static/media/logbook-logo.194d2d93.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logbook-logo.svg
// module id = 424
// module chunks = 0